import * as ACTION from "../../Redux.constants";
import { setNewCurrentChapter } from "./SetNewCurrentChapter";
import { setNotebookCollapse } from "./SetNotebookCollapse";

export function NotebookReducer(state, action) {
  switch (action.type) {
    case ACTION.SET_CHAPTER:
      return setNewCurrentChapter(state, action.payload);
    case ACTION.SET_COLLAPSE:
      return setNotebookCollapse(state, action.payload);
    default:
      return state;
  }
}
